import getInstance from './instance';

const instance = getInstance();

export const fetchCategories = () => {
  const url = '/category';

  return instance.get(url);
};
